function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useMemo, useRef, useLayoutEffect, useState } from 'react';
import { ResponsiveContext } from '../../context';
import ResponsiveItem from '../ResponsiveItem';
import Draggable from 'react-draggable';
import { makeLines } from '../../utils';
import styles from '../../style/index.module.scss';
import lodash from 'lodash';
import { Space, Button } from 'antd';
import Svg1 from '../../svg/1.svg';
import Svg2 from '../../svg/2.svg';
import Svg3 from '../../svg/3.svg';
import Svg4 from '../../svg/4.svg';
import Svg5 from '../../svg/5.svg';
import Svg6 from '../../svg/6.svg';
import Svg7 from '../../svg/7.svg';
import Svg8 from '../../svg/8.svg';
import Svg9 from '../../svg/9.svg';
export default (function () {
  var _useContext = useContext(ResponsiveContext),
    pageData = _useContext.pageData,
    _useContext$state = _useContext.state,
    sizeMap = _useContext$state.gridSizeMap,
    comps = _useContext$state.comps,
    onHandleChangeItemSize = _useContext.onHandleChangeItemSize,
    comDragingRef = _useContext.comDragingRef,
    onHandleSetGridGroup = _useContext.onHandleSetGridGroup;
  var containerRef = useRef(null);
  var resizingPosRef = useRef(false);
  var dragPos = useRef({
    startX: undefined,
    startY: undefined,
    dir: undefined
  });
  var dragLine = function dragLine(e, dir) {
    resizingPosRef.current = true;
    comDragingRef.current = true;
    dragPos.current = {
      startX: e.clientX,
      startY: e.clientY,
      dir: dir
    };
  };
  var onHandleStop = function onHandleStop(e, i, ex) {
    var arr = lodash.cloneDeep(sizeMap);
    comDragingRef.current = false;
    if (dragPos.current.dir == 'x') {
      var changeX = e.x;
      var changePercent = Math.round(changeX / containefWidth * 10000);
      arr.x[i] = (arr.x[i] * 100 + changePercent) / 100;
      arr.x[i + 1] = (arr.x[i + 1] * 100 - changePercent) / 100;
    } else if (dragPos.current.dir == 'y') {
      var changeY = e.y;
      arr.y[i] = arr.y[i] + changeY;
      if (ex && ex.bottom) {
        // 如果是最下面的一条线，只需要改变自己的高度，不需要减少下一层的高度
      } else {
        arr.y[i + 1] = arr.y[i + 1] - changeY;
      }
    }
    dragPos.current = {
      startX: undefined,
      startY: undefined,
      dir: undefined
    };
    onHandleChangeItemSize(arr);
  };
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    containefWidth = _useState2[0],
    setContainefWidth = _useState2[1];
  var gridTemplateData = useMemo(function () {
    var gridTemplateData = {
      gridTemplateRows: '',
      gridTemplateColumns: '',
      widthSum: 100
    };
    if (sizeMap.y.length > 0) {
      var _sizeMap$y;
      gridTemplateData.gridTemplateRows = (_sizeMap$y = sizeMap.y) === null || _sizeMap$y === void 0 ? void 0 : _sizeMap$y.map(function (i) {
        return i + 'px';
      }).join(' ');
    }
    if (sizeMap.x.length > 0) {
      gridTemplateData.gridTemplateColumns = sizeMap.x.map(function (i) {
        return i / 50 + 'fr';
      }).join(' ');
      gridTemplateData.widthSum = sizeMap.x.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue;
      }, 0);
    }
    return gridTemplateData;
  }, [sizeMap]);
  var LineGroupContent = useMemo(function () {
    if (containefWidth == 0 || pageData.length == 0) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    var allGrid = pageData.map(function (i) {
      return i.grid.split('/').map(Number);
    });
    var lineData = makeLines(allGrid);
    var bottomLine = /*#__PURE__*/React.createElement(Draggable, {
      key: 'bottomLine',
      position: {
        x: 0,
        y: 0
      },
      bounds: {
        top: -(sizeMap.y[sizeMap.y.length - 1] - 30)
      },
      axis: "y",
      onMouseDown: function onMouseDown(e) {
        dragLine(e, 'y');
      },
      onStop: function onStop(e, data) {
        onHandleStop(data, sizeMap.y.length - 1, {
          bottom: true
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['xline'],
      style: {
        height: '1px',
        width: sizeMap.x.reduce(function (accumulator, currentValue) {
          return accumulator + currentValue;
        }, 0) + '%',
        top: sizeMap.y.reduce(function (accumulator, currentValue) {
          return accumulator + currentValue;
        }, 0) - 1 + 'px',
        left: 0
      }
    }));
    var topLIne = /*#__PURE__*/React.createElement("div", {
      key: 'topLIne',
      className: styles['topline'],
      style: {
        width: sizeMap.x.reduce(function (accumulator, currentValue) {
          return accumulator + currentValue;
        }, 0) + '%',
        height: '1px',
        top: 0,
        left: 0
      }
    });
    var RightLine = /*#__PURE__*/React.createElement("div", {
      key: 'RightLine',
      className: styles['bothline'],
      style: {
        height: sizeMap.y.reduce(function (accumulator, currentValue) {
          return accumulator + currentValue;
        }, 0) + 'px',
        width: '1px',
        top: 0,
        right: '0'
      }
    });
    var LeftLine = /*#__PURE__*/React.createElement("div", {
      key: 'LeftLine',
      className: styles['bothline'],
      style: {
        height: sizeMap.y.reduce(function (accumulator, currentValue) {
          return accumulator + currentValue;
        }, 0) + 'px',
        width: '1px',
        left: 0,
        top: 0
      }
    });
    var alllines = [];
    if (!lineData) {
      alllines.push(bottomLine, topLIne, RightLine, LeftLine);
    } else {
      var lineXgroup = Object.keys(lineData.x);
      var lineYgroup = Object.keys(lineData.y);
      for (var _i = 0, _lineXgroup = lineXgroup; _i < _lineXgroup.length; _i++) {
        var i = _lineXgroup[_i];
        var _iterator = _createForOfIteratorHelper(lineData.x[i]),
          _step;
        try {
          var _loop = function _loop() {
            var j = _step.value;
            var index = Number(i) - 2;
            alllines.push( /*#__PURE__*/React.createElement(Draggable, {
              position: {
                x: 0,
                y: 0
              },
              bounds: {
                top: -(sizeMap.y[index] - 30),
                bottom: sizeMap.y[index + 1] - 30
              },
              axis: "y",
              onMouseDown: function onMouseDown(e) {
                dragLine(e, 'y');
              },
              onStop: function onStop(e, data) {
                onHandleStop(data, index);
              }
            }, /*#__PURE__*/React.createElement("div", {
              className: styles['xline'],
              style: {
                marginTop: '-1px',
                height: '2px',
                width: sizeMap.x.slice(j.start - 1, j.end - 1).reduce(function (accumulator, currentValue) {
                  return accumulator + currentValue;
                }, 0) + '%',
                top: sizeMap.y.slice(0, index + 1).reduce(function (accumulator, currentValue) {
                  return accumulator + currentValue;
                }, 0) + 'px',
                left: sizeMap.x.slice(0, j.start - 1).reduce(function (accumulator, currentValue) {
                  return accumulator + currentValue;
                }, 0) + '%'
              }
            })));
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      for (var _i2 = 0, _lineYgroup = lineYgroup; _i2 < _lineYgroup.length; _i2++) {
        var _i3 = _lineYgroup[_i2];
        var _iterator2 = _createForOfIteratorHelper(lineData.y[_i3]),
          _step2;
        try {
          var _loop2 = function _loop2() {
            var j = _step2.value;
            var index = Number(_i3) - 2;
            alllines.push( /*#__PURE__*/React.createElement(Draggable, {
              position: {
                x: 0,
                y: 0
              },
              bounds: {
                left: -(containefWidth * sizeMap.x[index]) / 100 + 30,
                right: containefWidth * sizeMap.x[index + 1] / 100 - 30
              },
              axis: "x",
              onMouseDown: function onMouseDown(e) {
                dragLine(e, 'x');
              },
              onStop: function onStop(e, data) {
                onHandleStop(data, index);
              }
            }, /*#__PURE__*/React.createElement("div", {
              className: styles['yline'],
              style: {
                width: '2px',
                marginLeft: '-1px',
                height: sizeMap.y.slice(j.start - 1, j.end - 1).reduce(function (accumulator, currentValue) {
                  return accumulator + currentValue;
                }, 0) + 'px',
                left: sizeMap.x.slice(0, index + 1).reduce(function (accumulator, currentValue) {
                  return accumulator + currentValue;
                }, 0) + '%',
                top: sizeMap.y.slice(0, j.start - 1).reduce(function (accumulator, currentValue) {
                  return accumulator + currentValue;
                }, 0) + 'px'
              }
            })));
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop2();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      alllines.push(bottomLine, topLIne, RightLine, LeftLine);
    }
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: '0',
        width: '100' + '%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 10,
        overflow: 'visible'
      }
    }, alllines);
  }, [pageData, gridTemplateData, sizeMap, containefWidth]);
  useLayoutEffect(function () {
    setContainefWidth(containerRef.current.getBoundingClientRect().width);
  }, [gridTemplateData]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-inner-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-inner-header']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-inner-content']
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-com_type": 'container',
    ref: containerRef,
    style: {
      display: 'grid',
      position: 'relative',
      width: '100%',
      boxSizing: 'border-box',
      gridTemplateRows: gridTemplateData.gridTemplateRows,
      gridTemplateColumns: gridTemplateData === null || gridTemplateData === void 0 ? void 0 : gridTemplateData.gridTemplateColumns
    }
  }, pageData.length > 0 ? pageData.map(function (item, i) {
    return /*#__PURE__*/React.createElement(ResponsiveItem, {
      key: item.com_id,
      data: item
    });
  }) : /*#__PURE__*/React.createElement("div", {
    style: {
      border: '1px solid #ddd'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      lineHeight: '20px',
      textAlign: 'center',
      padding: '40px'
    }
  }, "\u8BF7\u9009\u62E9\u60F3\u8981\u7684\u5E03\u5C40"), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: '20px 0 60px'
    }
  }, /*#__PURE__*/React.createElement(Space, null, /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg1, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(1);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg2, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(2);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg3, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(3);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg4, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(4);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg5, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(5);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg6, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(6);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg7, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(7);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg8, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(8);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    style: {
      background: '#fff',
      width: 30,
      height: 30
    },
    icon: /*#__PURE__*/React.createElement(Svg9, null),
    type: "default",
    onClick: function onClick() {
      onHandleSetGridGroup(9);
    }
  })))))), LineGroupContent), /*#__PURE__*/React.createElement("div", {
    className: styles['responsive-layout-inner-footer']
  }));
});